module.exports = __webpack_public_path__ + "img/4-1.ffd49d88.jpg";